import { Popover, Whisper } from "rsuite";
import DropdownOptionWithIcon from "../../Menus/DropdownOptionWithIcon";
import { TypeAttributes } from "rsuite/esm/internals/types";

interface Props {
  hide: boolean | string;
  onOpenSettings: () => void;
  onDelete: () => void;
  deleting: boolean;
  popoverOpen: boolean;
  setPopoverOpen: (open: boolean) => void;
  customComponent?: React.ReactNode;
  placement?: TypeAttributes.Placement;
}

export default function ProjectOptions({
  hide,
  onOpenSettings,
  onDelete,
  deleting,
  popoverOpen,
  setPopoverOpen,
  customComponent,
  placement,
}: Props) {
  return (
    <Whisper
      trigger="click"
      onEntering={() => setPopoverOpen(true)}
      onClose={() => setPopoverOpen(false)}
      placement={placement || "autoVerticalStart"}
      preventOverflow
      speaker={
        <Popover
          className={`sidebar-popover ${hide ? "tw:hidden" : ""}`}
          full
          onClick={(e: any) => {
            e.stopPropagation();
          }}
        >
          <DropdownOptionWithIcon
            name="Project Settings"
            onClick={onOpenSettings}
            icon="mdi mdi-cog"
          />
          <DropdownOptionWithIcon
            name="Delete Project"
            onClick={onDelete}
            icon="mdi mdi-delete"
            disabled={deleting}
          />
        </Popover>
      }
    >
      <div onClick={(e) => e.stopPropagation()}>
        {customComponent ? (
          customComponent
        ) : (
          <i
            className={`mdi mdi-dots-horizontal tw:cursor-pointer tw:px-1 tw:rounded tw:text-lg tw:leading-5 tw:bg-ultralight tw:hover:bg-white tw:hover:outline tw:hover:outline-gray-200 ${
              popoverOpen ? "tw:outline tw:outline-gray-200" : ""
            }`}
          />
        )}
      </div>
    </Whisper>
  );
}
